import React, { useCallback } from 'react';
import dayjs from 'dayjs';
import { CalendarEvent, FilterResponse, FilterType } from '../helpers/common-types';
import { SvgIcon } from './svg-icon';
import { useAppDispatch } from '../app/store';
import { useAppSelector } from '../app/hooks';
import { updateFilter } from '../features/calendar/calendar-slice';

export interface ListEventProps {
    event: CalendarEvent;
    categoryFilterOptions: FilterResponse[] | null;
}

export function ListEvent(props: ListEventProps) {
    const { event, categoryFilterOptions } = props;
    const dispatch = useAppDispatch();

    const currentCategoriesFilterState = useAppSelector(state => state.calendar.currentAppliedFilters[FilterType.CATEGORIES]);
    const buyTicketCtaDefaultText = useAppSelector(state => state.settings.buyTicketCtaDefaultText);

    const isFilterApplied = (filterValue: string) => {
        const match = currentCategoriesFilterState.value.filter(appliedFilterValue => {
            return filterValue === appliedFilterValue
        });
        return match.length > 0;
    }

    const filterClicked = (e: React.MouseEvent, filterValue: string) => {
        if (categoryFilterOptions) {
            const matchingOption = categoryFilterOptions.filter(option => option.value == filterValue);
            dispatch(updateFilter({
                filterType: FilterType.CATEGORIES, newState: {
                    value: [filterValue],
                    firstOccurance: matchingOption[0]?.firstOccurance
                }
            }))
        }
    }

    const getTitle = (name: string | undefined) => (<h4 className="ace-cal-list-event-name notranslate h3-style" dangerouslySetInnerHTML={{ __html: name || "" }}></h4>);
    const getCta = (buyTicketText: string | undefined) => buyTicketText ? buyTicketText : buyTicketCtaDefaultText;

    return (
        <>
            {
                !!event &&
                <li className={`ace-cal-list-event block-${event.theme}`}>
                    <article className="ace-cal-list-event-content">
                        <div className="ace-cal-list-event-image">
                            {
                                event.thumbnail &&
                                <img role="presentation" src={event.thumbnail} alt={event.thumbnailAltText} className="ace-cal-list-event-image-img" />
                            }
                        </div>
                        <div className="ace-cal-list-event-details stack-md">
                            {
                                event.viewDetailCtaUrl ?
                                    <a className="ace-cal-list-event-link notranslate" href={event.viewDetailCtaUrl}>{getTitle(event.name)}</a>
                                    : getTitle(event.name)
                            }
                            {
                                !!event.categories && event.categories.length > 0 ?
                                    <div className="spaced-list space-top">
                                        {
                                            event.categories.map(category => (
                                                <button onClick={(e) => filterClicked(e, category)} className={`btn-chip`} disabled={isFilterApplied(category)}>
                                                    {category}
                                                </button>
                                            ))
                                        }
                                    </div>
                                    : null
                            }
                            <div className="flex-between align-items-center">
                                <p className="ace-cal-list-event-venue h6-style themed-location notranslate">
                                    <svg className="svg-icon svg-icon-text" aria-hidden="true" focusable="false">
                                        <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#icon-location"></use>
                                    </svg>
                                    <span>{event.location}</span>
                                </p>
                                <p className="ace-cal-list-event-time h6-style ">{event.eventTimeString}</p>
                            </div>
                            {
                                !!event.synopsis && event.synopsis.length > 0 ?
                                    <div className="ace-cal-list-event-synopsis rich-text" dangerouslySetInnerHTML={{ __html: event.synopsis }}/>
                                    : null
                            }
                            {
                                !event.hideAvailability ?
                                    <p className={`availability-indicator availability-indicator-${event.availabilityType}`}>
                                        {event.availabilityText} </p>
                                    : null
                            }

                            <p className="ace-cal-list-event-cta">
                                {
                                    event.buyTicketCtaUrl ?
                                        <a href={event.buyTicketCtaUrl} className="btn btn-themed">{getCta(event.buyTicketCtaText)}</a>
                                        : <a href={event.viewDetailCtaUrl} className="btn btn-themed">Learn More</a>
                                }
                            </p>


                        </div>
                    </article>
                </li>
            }
        </>
    )
}